<template>
  <div class="auth">
    <Sign-In />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')

export default {
  name: 'Auth',
  components: {
    SignIn: () => import('./SignIn'),
  },
  computed: {
    ...mapAuthGetters([
      'isValidUser',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.auth {
  height: 100%;
}
</style>
